<template>
    <div v-if="showModal" class="modal fade show d-block z-3" tabindex="-1">
      <div @click="closeModal()" class="h-100 w-100 position-fixed z-1"></div>
      <div class="modal-dialog z-2 m-4 d-flex align-items-center justify-content-center">
        <div class="modal-content">
          <div class="modal-header d-flex align-items-center justify-content-center border-none">
            <h3 class="modal-title">Eliminar Categoría</h3>
          </div>
          <div class="modal-body">
            <p class="text-center">¿Estás seguro que deseas eliminar la categoría "{{ category.name }}"?</p>
            <p class="text-center text-danger fw-bold">
              ¡Esta acción eliminará todos los platos asociados a esta categoria!
            </p>
          </div>
          <div class="modal-footer d-flex justify-content-center border-none">
            <button type="button" class="btn text-white" style="background-color: var(--primary-color);" @click="closeModal">Cancelar</button>
            <button type="button" class="btn btn-danger" @click="confirmDelete">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        props: {
            showModal: Boolean,
            category: Object,
        },
        methods: {
            closeModal() {
                this.$emit('close-modal');
            },
            confirmDelete() {
                this.$emit('confirm-delete', this.category.id);
            },
        },
    };
</script>

<style scoped>
  .modal { 
    background-color: rgba(139, 139, 139, 0.5); 
  }

  .modal-dialog {
    height: 90vh; 
    min-width: 60%;
  }

  .modal-content {
    max-height: 90vh;
  }

  @media (min-width: 767px) {
    .modal-dialog {
      position: absolute;
      width: 80%;
      left: 28%;
      min-height: 90vh; 
      min-width: 60%; 
    }
  }

  @media (max-width: 576px) {
    .modal-dialog {
      max-width: 90%;
      margin: 0 auto;
    }
  }
</style>